<template>
  <div>
    <el-button class="btn" type="primary" @click="getpdf" style="display: flex;">下载pdf文件</el-button>
    <div id="print" ref="print" style="width: ;">
      <div class="result_tip">
        <div class="flex tip1_1">
          <span>用户名：{{ data.user.nickname }} <i style="margin: 0 10px;" /> 手机号：{{ data.user.mobile }}</span>
        </div>
        <div class="flex tip1_1">
          <span>{{ data.year }}·河南·{{ data.enroll_type }}·{{ data.batch_name }}.{{ data.score }}分</span>
        </div>

        <div class="tip1">您的审核结果如下：</div>
      </div>
      <div class="result">
        <div v-for="(item,index) in data.detail" :key="index" class="result-one">
          <!-- <div class="result-one_head">
            志愿{{ index+1 }}
          </div> -->
          <div class="result-one_main">
            <div class="flex main1">
              <span class="name">第{{ index+1 }}志愿</span>
              <span v-if="item.id" class="content">[{{ item.enroll_code }}]{{ item.school_name }}</span>
              <span v-else class="content">暂无</span>
            </div>
            <div v-for="(item1,index) in item.major" :key="index" class="flex main1">
              <span class="name">专业{{ index+1 }}</span><span
                class="content">[{{ item1.major_code }}]{{ item1.major_name }}({{ item1.major_detail }})</span>
            </div>
          </div>
          <!-- <div class="result-one_main">
            <div class="flex">
              <span class="name">第{{ index+1 }}志愿</span><span
                class="content"
              >[{{ item.id }}]{{ item.school_name }}</span>
            </div>
            <div v-for="(item1,index) in item.major" :key="index" class="flex">
              <span class="name">专业{{ index+1 }}</span><span
                class="content"
              >[{{ item1.major_code }}]{{ item1.major_name }}({{ item1.major_detail }})</span>
            </div>
          </div> -->
        </div>

      </div>

      <div class="tip2" style="margin: 20px;">
        本系统数据仅供参考,公司不承担任何责任！最终解释权归本公司所有
      </div>
      <div style="margin: 20px;font-size: 20px;text-align: left;">
        签名：
      </div>
    </div>
  </div>
</template>

<script>
  import pdf from '../../../static/pdf.js'
  export default {
    data() {
      return {
        data: [],
        set: [],
        current: 0,
        exportPDFtitle: '志愿单',
        print: {
          id: 'print',
          popTitle: '志愿单', // 打印配置页上方的标题
          extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
          preview: true, // 是否启动预览模式，默认是false
          previewTitle: '志愿单', // 打印预览的标题
          previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
          zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
          previewBeforeOpenCallback() {
            console.log('正在加载预览窗口！')
          }, // 预览窗口打开之前的callback
          previewOpenCallback() {
            console.log('已经加载完预览窗口，预览打开了！')
          }, // 预览窗口打开时的callback
          beforeOpenCallback() {
            console.log('开始打印之前！')
          }, // 开始打印之前的callback
          openCallback() {
            console.log('执行打印了！')
          }, // 调用打印时的callback
          closeCallback() {
            console.log('关闭了打印工具！')
          }, // 关闭打印的callback(无法区分确认or取消)
          clickMounted() {
            console.log('点击v-print绑定的按钮了！')
          },
          standard: '',
          extarCss: ''
        }
      }
    },
    created() {
      this.$http.customCheckDetail({
        id: this.$route.query.id
      }).then(res => {
        this.data = res.data
        console.log(this.data)
      })
      //console.log(`http://www.qingpinji.com/ldks/5656/2344265_2.html`)
      // if(options.schoolid){
      // 	this.$u.api.simulatedDetail({
      // 		id: options.schoolid
      // 	}).then(res => {
      // 		this.data = res.data.result
      // 	})
      // }else{
      // 	this.$u.api.checkMajorSimulatedDetail({
      // 		id: options.id
      // 	}).then(res => {
      // 		this.data = res.data.result
      // 	})
      // }
    },
    methods: {
      getpdf() {
        this.$nextTick(() => {
          this.getPdf()
          this.$http.intentionRrintCount({
            id: this.$route.query.id
          }).then(res => {

          })
        })
      },
      goindex() {
        uni.switchTab({
          url: '../index/index'
        })
      },

      change(index) {
        this.current = index
      }
    }
  }
</script>

<style scoped lang="scss">
  .result {
    font-size: 13px !important;
    span-align: center;
    margin: 10px 0 0 30px;
    width: 590px;

    .name {
      display: inline-block;
      width: 300px;
      // border-right: 1px solid #999999;
    }

    .content {
      display: inline-block;
      border-left: 1px solid #999999;
      width: 700px;
      text-align: left;
    }

    .result-one_main>div {
      border-bottom: 1px solid #999999;
      min-height: 30px;
      line-height: 30px;

      span {
        padding: 0 0 0 10px;
      }
    }

    .result-one_head {
      border-bottom: 1px solid #999999;
      // min-height: 40px;
      // line-height: 40px;
    }
  }

  .result-one {
    border: 1px solid #999999;
    margin-bottom: 10px;
    border-bottom: none;
  }

  .btn {
    margin-top: 20px;
    margin-left: 40px;
  }

  .index {
    width: 74px;
    height: 44px;
    background: #19CACA;
    display: inline-block;
    border-bottom-right-radius: 40px;
    span-align: center;
    color: #FFFFFF;
  }

  .reset {
    width: 100%;
    height: 90px;
    span-align: center;
    line-height: 90px;
    color: #FFFFFF;
    background: #19CACA;
    position: fixed;
    bottom: 0;

    /* 	span {
			width: 50%;
		}

		span:nth-child(1) {
			background-color: #FFBD09;
		}

		navigator {
			color: #FFFFFF;
		}

		span:nth-child(2) {
			background-color: #F86A4B;
		} */
  }

  .list {
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 19px;

    /* span {
			width: 50%;
			display: inline-block;
		} */
  }

  .rate1 {
    font-size: 16px;
    color: #19CACA;
    margin-left: 10px;
    text-align: center;
  }

  .rate2 {
    font-size: 16px;
    color: #FFBD09;
    margin-left: 10px;
    text-align: center;
  }

  .rate3 {
    font-size: 16px;
    color: #F86A4B;
    margin-left: 10px;
    text-align: center;
  }

  .status {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 9px;
    background-color: #19CACA;
    border-radius: 50%;
    font-size: 16px !important;
  }

  .status1 {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 9px;
    background-color: #FFBD09;
    border-radius: 50%;
    font-size: 16px !important;
  }

  .status2 {
    width: 16px;
    font-size: 16px !important;
    height: 16px;
    display: inline-block;
    margin-right: 9px;
    background-color: #F86A4B;
    border-radius: 50%;
  }

  .list>span {
    margin-bottom: 25px;
  }

  .resultInfo {
    margin: 0 0px;
  }

  .result {
    font-size: 18px;
    span-align: center;
    margin: 10px 0 0 30px;
  }

  .schoolList {
    margin: 25px 31px 110px 31px;
  }

  .flex {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .schoolInfo {
    margin: 17px 81px 0px 0px;
    border-bottom: 1px solid #19CACA;
    /* min-height: 140px; */
    color: #999999;
    font-size: 16px;
    padding-bottom: 10px;
    text-align: left;
    /* span:nth-child(1) {
  		color: #333333;
  		font-weight: bold;
  		margin-right: 32px;
  		margin-top: 27px;
  		font-size: 34px;
  	} */
  }

  .fucong {
    color: #19CACA;
    font-size: 16px;
    margin: 19px 0 15px 0;
  }

  .one {}

  .tab {
    margin: 0 69px;
    justify-content: space-between;
  }

  .active {
    /* background: url(../../static/tab_bg.png)no-repeat; */
    width: 245px;
    height: 76px;
    background-size: contain;
    color: #FFFFFF;
  }

  .tip2 {
    width: 100%;
    text-align: left;
    color: red;
    font-size: 20px;
  }

  .result_tip {
    font-size: 22px;
    margin: 47px 0 0 32px;

    color: #19CACA;
  }

  .tip1 {
    color: #333333;
    margin-bottom: 10px;
    text-align: left;
  }

  .flex {
    flex-wrap: nowrap;
  }

  .tip1_1 {
    justify-content: space-between;
    margin: 10px 31px 10px 0;
  }

  .tip1_2 {
    font-size: 20px;

    span {
      margin-left: 18px;
      position: relative;
      color: #333333;
    }
  }

  .tip1_2 span:nth-child(1)::before {
    content: '';
    position: absolute;
    top: -20px;
    width: 18px;
    height: 18px;
    background-color: #19CACA;
    border-radius: 50%;
    left: 15px;
  }

  .tip1_2 span:nth-child(2)::before {
    content: '';
    position: absolute;
    top: -20px;
    width: 18px;
    height: 18px;
    background-color: #FFBD09;
    border-radius: 50%;
    left: 15px;
  }

  .tip1_2 span:nth-child(3)::before {
    content: '';
    position: absolute;
    top: -20px;
    width: 18px;
    height: 18px;
    background-color: #F86A4B;
    border-radius: 50%;
    left: 15px;
  }

  .tablehead {
    width: 979px;
    height: 51px;
    background: #FAFAFA;
    line-height: 51px;
    margin-left: 32px;
    text-align: center;
  }

  .tablehead span {
    display: inline-block;
  }

  .tip {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin: 12px auto;
  }

  .add {
    width: 980px;
    height: 50px;
    line-height: 50px;
    background: #E8FAFA;
    border: 1px solid #19CACA;
    border-radius: 4px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #19CACA;
    text-align: center;
    cursor: pointer;
  }

  .tip {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin: 12px auto;
  }

  .code {
    color: #19CACA;
    margin-left: 18px;
    // line-height: 26px;
  }

  .zhuanyeRate {
    color: #FEBD0C;
    font-size: 24px
  }

  .schoolRate {
    margin-top: 10px;

    .rate1 {
      font-size: 14px;
      color: #19CACA;
    }

    .rate2 {
      font-size: 14px;
      color: #FFBD09;
    }

    .rate3 {
      font-size: 14px;
      color: #F86A4B;
    }

    & span:nth-child(1) {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-color: red;
      border-radius: 5px;
      color: #FFFFFF;
      line-height: 24px;
      margin-right: 7px;
    }

    & span:nth-child(2) {
      font-size: 24px
    }
  }

  .schoolinfo {
    display: flex;
    align-items: center;
    justify-content: center;

    & p:nth-child(1) {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }

    & p:nth-child(2) {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin: 10px 0 10px 0;
      color: #999999;
    }

  }

  .code {

    margin: 13px 0 14px 20px;

  }

  .zhuanye {
    text-align: left;
    border-left: 1px solid #19caca;

    &>div {
      // height: 80px;
      margin: 5px 0 5px 20px;
      // border-bottom: 1px solid #19caca;
    }
  }

  .tablemain {
    width: 979px;
    border-top: 1px solid #19caca;
    margin-left: 32px;
    min-height: 122px;
  }

  .tableone {
    page-break-before: always;
    width: 979px;
    border: 1px solid #19caca;
    border-top: none;
    align-items: normal;
    min-height: 120px;

    &>div {
      display: inline-block;
    }
  }

  .right {
    width: 900px;
    margin-left: 40px;
  }

  .active {
    font-weight: 400;
    color: #19CACA;
    background: #D1F4F4;
  }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }

  .batch {
    image {
      width: 28px !important;
      height: 22px;
    }

    .listone1 {
      margin: 10px 44px;
      border: 1px solid #E6E6E6;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 22px;
      text-align: left;

      text {
        font-size: 16px;
        color: #797373 !important;
        margin-right: 19px;
      }

      image {
        width: 14px;
        height: 25px;
      }

      .left1 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-top: 14px;
      }

      .left2 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        margin: 19px 0 15px 0;
      }

      .left3 {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #19CACA;
      }
    }
  }

  .confirm {
    width: 558px;
    // height: 456px;
    background: #FFFFFF;
    border-radius: 10px;
    z-index: 1000;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -279px;
    margin-top: -228px;

    button {
      width: 100px;
      height: 40px;
      background: #19CACA;
      border-radius: 20px;
      border: none;
      outline: none;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }

    .right_tip {
      position: absolute;
      right: 30px;
      top: 10px;
    }

    .form>div {
      margin-bottom: 34px;
      position: relative;

      span {
        width: 64px;
        height: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .form input {
      width: 387px;
      height: 41px;
      border: 1px solid #E6E6E6;
      border-radius: 20px;
      outline: none;
      margin-left: 38px;
      text-indent: 23px;
    }

    .head {
      margin: 47px 77px 44px 70px;

      span {
        display: inline-block;
        width: 50%;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
      }
    }
  }

  .form {
    padding-bottom: 40px;
  }

  .sure {
    width: 299px !important;
    height: 40px;
    background: #19CACA;
    border-radius: 20px;
    margin-top: 27px;
  }

  .selected {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333 !important;
  }

  .change {
    width: 205px;
    height: 151px;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .current {
    width: 324px;
    height: 39px;
    line-height: 39px;
    border-radius: 10px;
    margin-bottom: 12px;
    color: #FA6002;

    span {
      display: inline-block;
    }

    .dangqian {
      width: 236px;
    }
  }

  .score {
    width: 176px;
    height: 80px;
    border-radius: 6px;
    background-color: #E8FAFA;
    margin: 18px auto;
    line-height: 25px;
    color: #19CACA
  }

  .line {
    margin: 25px 0 18px 0;
    color: #19CACA
  }

  .info {
    // width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;

    button {
      width: 177px;
      height: 33px;
      border: 1px solid #19CACA;
      border-radius: 6px;
      background-color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #19CACA;
      margin-top: 15px;
    }

    &>p {
      width: 100%;
      text-align: left;
      margin: 20px 0px 20px 24px;
    }

    .head {
      height: 60px;
      background: #19CACA;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  .change {
    width: 205px;
    height: 151px;
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    border-radius: 10px;

    p {
      width: 204px;
      height: 50px;
      line-height: 50px;
    }
  }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }
</style>



// WEBPACK FOOTER //
// src/view/me/customDetail.vue